import React from 'react';
import PropTypes from 'prop-types';
import SocialIcon from 'wonderbly-components/lib/SocialIcon';

import './SocialNetworks.scss';

const SocialNetworks = props =>
  (<div className="SocialNetworks">
    {props.socialNetworks.map(network =>
      (<SocialIcon
        key={network.name}
        network={network.name}
        href={network.url}
        rel={(network.url || '').startsWith('http') ? 'nofollow noopener' : null}
      />)
    )}
  </div>);

SocialNetworks.propTypes = {
  socialNetworks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SocialNetworks;
